var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['value-dropdown-option', { 'disabled': _vm.disabled }, _setup.props.type],on:{"click":() => !_vm.disabled && _setup.emit('click')}},[(_vm.imgSrc)?_c('img',{staticClass:"mr-8",attrs:{"src":_vm.imgSrc}}):_vm._e(),_c('div',{staticClass:"value-dropdown-option-label"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }